{
	"choiceCommercial": "Commercial",
	"choiceConference": "Conference",
	"choiceDocumentary": "Documentary",
	"choiceEmail": "Email",
	"choiceEvent": "Event",
	"choiceFacebook": "Facebook",
	"choiceFamily": "Family",
	"choiceFriend": "Friend",
	"choiceGoogleSearch": "Google Search",
	"choiceInstagram": "Instagram",
	"choiceLandscape": "Landscape",
	"choiceNewsArticle": "News Article",
	"choiceOther": "Other",
	"choicePortrait": "Portrait",
	"choiceRealEstate": "Real Estate",
	"choiceSport": "Sport",
	"choiceTikTok": "TikTok",
	"choiceWedding": "Wedding",
	"choiceYoutube": "Youtube",
	"done": "Done",
	"howDidYouHear": "How did you hear about us?",
	"next": "Next",
	"whatKindOfPhotos": "What kind of photos do you shoot professionally the most?"
}
